import { PaymentElement } from '@stripe/react-stripe-js/checkout';
import type { StripeCheckoutPaymentElementOptions } from '@stripe/stripe-js';
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import { Environment } from '../../util/Environment';

const DEFAULT_OPTIONS: StripeCheckoutPaymentElementOptions = {
  terms: { card: 'never' },
  fields: {
    billingDetails: {
      name: 'auto', // Needed for some payment methods like After Pay
      email: 'never',
      phone: 'never',
      address: 'never',
    },
  },
  wallets: { link: 'never', googlePay: 'auto', applePay: 'auto' },
};

/** Stripe `PaymentElement` with default options set, or `MockPaymentElement` for cypress. */
export const StripePaymentElement: FunctionComponent = () => {
  return Environment.E2E_TESTING ? (
    <MockPaymentElement />
  ) : (
    <PaymentElement options={DEFAULT_OPTIONS} />
  );
};

/** Mock PaymentElement with the same inputs as the real Stripe PaymentElement.
 *
 * Cypress electron is prone to crash when the PaymentElement is rendered. This mock is a
 * workaround to avoid the crash.
 */
const MockPaymentElement: FunctionComponent = () => (
  <Container data-test="mockPaymentElement">
    <Input type="number" placeholder="Card Number" id="payment-numberInput" />
    <Input type="text" placeholder="Expiry" id="payment-expiryInput" />
    <Input type="number" placeholder="CVC" id="payment-cvcInput" />
  </Container>
);

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  padding: 10px;
`;

const Input = styled.input`
  border: none;
  outline: none;
  padding: 10px;
  border-radius: 8px;
`;
